import { Typography } from '../../../../components/Typography/Typography';
import React from 'react';

interface BuilderTestComponentProps {
    // Define any props you want to pass to the component
    headline?: string;
    subHeadline?: string; // Optional subheadline prop
    headlineColor?: string; // Optional color prop for the headline
    description?: string;
    descriptionColor?: string; // Optional color prop for the description
    imageURL?: string;
    imageAltText?: string;
    headlineTypographyVariant?:
        | 'h1Hero'
        | 'h1SmallTitle'
        | 'h2SubheadLg'
        | 'h2SubheadSm'
        | 'h3SubpointLg'
        | 'h3SubpointSm'
        | 'h4Footer'
        | 'h5Subheader'
        | 'h6FormSubheader';
}

export function BuilderTestComponent({
    headline,
    description,
    imageURL,
    imageAltText,
    headlineColor,
    descriptionColor,
    headlineTypographyVariant = 'h1Hero', // Default to h1Hero if not provided
    subHeadline,
}: BuilderTestComponentProps) {
    return (
        <>
            <div className="flex flex-col items-center justify-center mcl-p-4 mcl-max-w-7xl mcl-mx-auto">
                {/* headline */}
                <Typography
                    variant={headlineTypographyVariant}
                    tag="h1"
                    color={headlineColor || 'Navy'}
                    className="mcl-text-center"
                >
                    {headline || 'Builder Test Component'}
                </Typography>
                {/* sub Headline */}
                <Typography variant={'h2SubheadSm'} tag="p" color={descriptionColor || 'Navy'} className="mcl-mt-4">
                    {subHeadline || 'This is a test component for the builder. You can customize it as needed.'}
                </Typography>

                {/* description */}
                <Typography variant={'pDefault'} tag="p" color={descriptionColor || 'Navy'} className="mcl-mt-4">
                    {description || 'This is a test component for the builder. You can customize it as needed.'}
                </Typography>
                {/* image */}
                <div className="py-10" />
                <img
                    src={imageURL || 'https://via.placeholder.com/400'}
                    alt={imageAltText || 'Placeholder Image'}
                    className="mcl-mt-4 mcl-rounded-lg mcl-shadow-lg"
                />
                {/* buttons */}
                <div className="mcl-mt-4">
                    <button
                        className="bg-red-700 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
                        onClick={() => alert('Primary Button Clicked')}
                    >
                        Primary Button
                    </button>
                </div>
            </div>
        </>
    );
}
